import { GOOGLE_MAPS } from '../constants/endpoints';

const MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
const PLACES_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_KEY;
const { MAPS_STATIC_MAP_BASE_URL } = GOOGLE_MAPS;
const { PLACE_PHOTO_BASE_URL } = GOOGLE_MAPS;
export const { MAP_WEB_VIEW_URL } = GOOGLE_MAPS;

interface ICenter {
    latitude: number,
    longitude: number
}

interface IStaticMap {
    center: ICenter;
    zoom: string;
    size: string;
}

interface IPlacePhoto {
    maxWidth: string;
    ref: string;
}

export const getStaticMapUrl = ({ center: { latitude, longitude }, zoom, size }:IStaticMap) => `${MAPS_STATIC_MAP_BASE_URL}center=${latitude},${longitude}&zoom=${zoom}&size=${size}&markers=size:mid|color:red|label:|${latitude},${longitude}&key=${MAPS_API_KEY}&sensor=false`;

export const getPlacePhoto = async ({ maxWidth = '400', ref }: IPlacePhoto) => `${PLACE_PHOTO_BASE_URL}&maxwidth=${maxWidth}&photoreference=${ref}&key=${PLACES_API_KEY}`;
